import React, {
    Fragment,
    useEffect,
    useState
} from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from 'moment';
import {
    Badge,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    Spinner,
    Table
} from "reactstrap";
import Skeleton from '../../../components/vwSkeleton/vwSkeleton'
import VWModel from '../../../components/vwModal/vwModal'
import { getPager } from "../../../helper/common";
import VWPagination from "../../../components/vwPagination/vwPagination";
import NoRecord from "../../../components/NoRecords/noRecords";
import {
    CUSTOMER,
    MANUFACTURER,
    ORGANIZATION_ADMIN,
    RETAILER,
    SUPER_ADMIN
} from "../../../store/users/role.constants";
import Message from "../../../CommonData/Data/Message";
import VWLoading from "../../../components/vwLoading/vwLoading";
import "../../FixedColumn.css";
import AddReturnReason from "./AddReturnReason";
import {
    closeCreateReturnReasonModal,
    getReturnReasonList,
    openCreateReturnReasonModal,
    setReturnReasonDetails,
    updateReturnReason
} from "../../../store/settings/returnReason/actions";
import { setIsInlineUpdate } from "../../../store/settings/SettingsInlineUpdate/actions";

const style = {
    table: {
        width: '100%',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'separate',
    },
    th: {
        top: 0,
        left: 0,
        zIndex: 2,
        position: 'sticky',
        backgroundColor: '#fff',
    },
};

const ReturnReasonList = (props) => {
    const { returnReasonList, isReturnReasonPending, isCreateReturnReasonModalOpen, currentProfile, errorMessage } = props;
    const [pageSize, setPageSize] = useState(10);
    const [pager, setPager] = useState({ currentPage: 1 });
    const [filter, setFilter] = useState();

    const isAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
        (currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);
    const isManufacturer = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === MANUFACTURER

    ///-----------------------FILTER------------------------------------------------
    const buildQueryReason = () => {
        const { reason } = filter || {};
        let searchReason = '';
        if (reason) {
            searchReason += `${reason}`;
        }
        return searchReason
    }

    const buildQueryIsActive = () => {
        const { isActive } = filter || {};
        let searchIsActive = '';
        if ((isActive !== null) && (isActive !== undefined)) {
            searchIsActive += `${isActive}`;
        }
        return searchIsActive
    }

    const buildQueryCreatedBy = () => {
        const { createdBy } = filter || {};
        let searchCreatedBy = '';
        if (createdBy) {
            searchCreatedBy += `${createdBy}`;
        }
        return searchCreatedBy
    }
    const buildQueryCreatedTimeStamp = () => {
        const { createdTimeStamp } = filter || {};
        let searchCreatedTimeStamp = '';
        if (createdTimeStamp) {
            searchCreatedTimeStamp += `${createdTimeStamp}`;
        }
        return searchCreatedTimeStamp
    }

    const setPage = (page = 1) => {
        props.getReturnReasonList(page, pageSize, buildQueryReason(), buildQueryIsActive(), buildQueryCreatedBy(), buildQueryCreatedTimeStamp(), sortDirection, sortOrder);
        setPager(prevPager => {
            const totalPages = Math.ceil(props.totalRecords / pageSize);
            const visiblePages = 5;
            const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
            const newPages = [];
            for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
                newPages.push(i);
            }
            return {
                ...prevPager,
                currentPage: page,
                totalPages,
                pages: newPages,
            };
        });
    };

    useEffect(() => {
        const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
        setPager(currentUpdatePager);
        props.setIsInlineUpdate();

        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClearClick();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [props.totalRecords, pageSize]);

    useEffect(() => {
        setPage();
    }, [pageSize])

    const searchInputValidation = (event) => {
        const input = event.target;
        const { value } = input;

        setFilter({
            ...filter,
            [input.name]: value,
        });
    };

    const handleSearchClick = () => {
        setPage();
    };

    const handleKeypress = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    useEffect(() => {
        if (filter) {
            handleSearchClick();
        }
    }, [filter])

    //-----------------------SORTING------------------------------------------------

    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);

    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };
    useEffect(() => {
        if (sortOrder && sortDirection) {
            setPage();
        }
    }, [sortOrder, sortDirection])


    const handleClose = () => {
        props.closeCreateReturnReasonModal();
    };

    const handleOpenCreateProduct = () => {
        props.openCreateReturnReasonModal();
    };

    const [errors, setErrors] = useState();
    const [Active, setActive] = useState();
    const [editInlineList, setEditInlineList] = useState({ reason: '' });

    const handleEditClick = (itemId, IsActive, reason) => {
        props.setIsInlineUpdate(itemId);
        setActive(IsActive);
        setEditInlineList({ ...editInlineList, reason: reason, isActive: IsActive, id: itemId });
        setErrors({});
    };
    const handleClearClick = () => {
        props.setIsInlineUpdate(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditInlineList({
            ...editInlineList,
            [name]: value
        });
        setErrors(prevErrors => ({
            ...prevErrors,
            [editInlineList.Id]: {
                ...prevErrors[editInlineList.Id],
                [name]: value ? null : `reason is required`
            }
        }));
    }
    const handleActiveStatusChange = () => {
        setEditInlineList({
            ...editInlineList,
            isActive: !Active
        })
        setActive(!Active)
        setErrors({
            ...errors,
            isActive: null
        })
    }

    const handleSave = (e) => {
        let currentErrors = {};
        const { reason } = editInlineList || {};

        if (!reason) {
            currentErrors.scopeName = 'Scope name is required';
        }
        setErrors(prevErrors => ({
            ...prevErrors,
            [editInlineList.Id]: currentErrors
        }));
        if (Object.keys(currentErrors).length === 0) {
            props.updateReturnReason(editInlineList)
        }
    }
    console.log("isInlineEditID: ", props.isInlineEditID);
    return (
        <>
            <React.Fragment>
                <div className="page-content">
                    <Card>
                        <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
                            RETURN REASON
                            <Link
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={handleOpenCreateProduct}
                            >
                                <em className="fas fa-plus me-2"></em> Add Reason
                            </Link>
                        </CardTitle>
                    </Card>
                    <Card className='p-4'>
                        {errorMessage && (
                            <Message
                                type="danger"
                                defaultMessage={errorMessage}
                                baseClassName="alert"
                            />
                        )}
                        <div style={{ maxHeight: "500px", overflowX: "auto" }}>
                            <Table className="table table-hover table-nowrap w-100" size="sm" style={style.table}>
                                <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: '10' }}>
                                    <tr>
                                        <th style={{ cursor: "pointer" }} onClick={() => handleSort('reason')}>
                                            REASON
                                            {sortOrder === 'reason' && (
                                                <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                                            )}
                                        </th>
                                        <th style={{ cursor: "pointer" }} onClick={() => handleSort('isActive')}>
                                            STATUS
                                            {sortOrder === 'isActive' && (
                                                <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                                            )}
                                        </th>
                                        <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdBy')}>
                                            CREATED BY
                                            {sortOrder === 'createdBy' && (
                                                <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                                            )}
                                        </th>
                                        <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdTimeStamp')}>
                                            CREATED ON
                                            {sortOrder === 'createdTimeStamp' && (
                                                <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                                            )}
                                        </th>
                                        <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}>
                                            ACTION
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormGroup>
                                                <Input
                                                    className="form-control"
                                                    placeholder="Search"
                                                    name="reason"
                                                    onChange={searchInputValidation}
                                                    onKeyPress={handleKeypress}
                                                    value={filter && filter.reason}
                                                />
                                            </FormGroup>
                                        </th>
                                        <th className="text-center">
                                            <FormGroup>
                                                <select
                                                    className="form-control"
                                                    name="isActive"
                                                    onChange={searchInputValidation}
                                                    value={filter && filter.isActive}
                                                >
                                                    <option value="">Select</option>
                                                    <option value={true}>Active</option>
                                                    <option value={false}>Inactive</option>
                                                </select>
                                            </FormGroup>
                                        </th>
                                        <th>
                                            <FormGroup>
                                                <Input
                                                    className="form-control"
                                                    placeholder="Search"
                                                    name="createdBy"
                                                    onChange={searchInputValidation}
                                                    onKeyPress={handleKeypress}
                                                    value={filter && filter.createdBy}
                                                />
                                            </FormGroup>
                                        </th>
                                        <th>
                                            <FormGroup>
                                                <Input
                                                    className="form-control"
                                                    type="date"
                                                    placeholder="Search"
                                                    name="createdTimeStamp"
                                                    onChange={searchInputValidation}
                                                    onKeyPress={handleKeypress}
                                                    value={filter && filter.createdTimeStamp}
                                                />
                                            </FormGroup>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(returnReasonList && returnReasonList.length > 0) && !isReturnReasonPending ?
                                        returnReasonList.map((data, index) => (
                                            <tr key={index} className="align-middle">
                                                <td>{(props.isInlineEditID === data.id) ?
                                                    <Input
                                                        autoFocus={props.isInlineEditID === data.id}
                                                        type="text"
                                                        name="reason"
                                                        placeholder="Enter reason"
                                                        onChange={handleInputChange}
                                                        value={data.reason || ""}
                                                    />
                                                    : (data.reason || "NA")
                                                }</td>
                                                <td className="align-middle">
                                                    {(props.isInlineEditID === data.id) ?
                                                        <FormGroup>
                                                            <ul className="form-settings-unstyled-list form-settings-status-list mt-3">
                                                                <li
                                                                    onClick={handleActiveStatusChange}
                                                                    className={`form-settings-status-item ${!Active ? 'active' : ''}`}
                                                                >
                                                                    Inactive
                                                                </li>
                                                                <li
                                                                    onClick={handleActiveStatusChange}
                                                                    className={`form-settings-status-item ${Active ? 'active' : ''}`}
                                                                >
                                                                    Active
                                                                </li>
                                                            </ul>
                                                        </FormGroup>
                                                        : data.isActive ? (
                                                            <Badge color="success">Active</Badge>
                                                        ) : (
                                                            <Badge color="danger">Inactive</Badge>
                                                        )
                                                    }
                                                </td>
                                                <td>{data.createdBy || "NA"}</td>
                                                <td>{data.createdTimeStamp ? moment(data.createdTimeStamp).format("DD MMM YYYY") : "NA"}</td>
                                                <td className="text-center sticky-column bg-white">
                                                    {(props.isInlineEditID === data.id) ?
                                                        <td>
                                                            <>
                                                                <i className="fas fa-check"
                                                                    style={{ color: "green", cursor: "pointer", marginLeft: '10px', fontSize: '18px' }}
                                                                    onClick={() => handleSave()}
                                                                />
                                                                <i
                                                                    className="fas fa-times"
                                                                    style={{ color: "red", cursor: "pointer", marginLeft: '10px', fontSize: '18px' }}
                                                                    onClick={() => handleClearClick(data.Id)}
                                                                />
                                                            </>
                                                        </td>
                                                        :
                                                        <td>
                                                            <i className="far fa-edit"
                                                                style={{ color: "black", cursor: "pointer", marginLeft: '10px' }}
                                                                onClick={() => handleEditClick(data.id, data.isActive, data.reason)}
                                                            />
                                                        </td>
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                        : isReturnReasonPending ?
                                            <tr>
                                                <td colSpan={9} align="center" className="p-4">
                                                    <Skeleton type="body" />
                                                    <VWLoading />
                                                </td>
                                            </tr>
                                            :
                                            <tr>
                                                <td colSpan={9}>
                                                    <NoRecord />
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </Table>
                        </div>
                        <CardFooter>
                            {returnReasonList && returnReasonList.length > 0 ?
                                <VWPagination
                                    pager={pager}
                                    setPage={setPage}
                                    totalRecords={props.totalRecords}
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                /> : null
                            }
                        </CardFooter>
                        <VWModel
                            header="ADD RETURN REASON"
                            isOpen={isCreateReturnReasonModalOpen}
                            handleClose={handleClose}
                        >
                            <AddReturnReason handleClose={handleClose} />
                        </VWModel>
                    </Card>


                </div >
            </React.Fragment >
        </>
    )
}

const mapStateToProps = (state) => ({
    isCreateReturnReasonModalOpen: state.returnReason.isCreateReturnReasonModalOpen,
    returnReasonList: state.returnReason.returnReasonList,
    errorMessage: state.returnReason.returnReasonListError,
    totalRecords: state.returnReason.totalRecords,
    isReturnReasonPending: state.returnReason.isReturnReasonPending,
    currentProfile: state.login.currentProfile,
    isInlineEditID: state.SettingsInlineEdit.isInlineEditID,
});

const mapDispatchToProps = (dispatch) => ({
    getReturnReasonList: (page, currentPage, searchReason, searchIsActive, searchCreatedBy, searchCreatedTimeStamp, sortDirection, sortOrder) =>
        dispatch(getReturnReasonList(page, currentPage, searchReason, searchIsActive, searchCreatedBy, searchCreatedTimeStamp, sortDirection, sortOrder)),
    openCreateReturnReasonModal: () => dispatch(openCreateReturnReasonModal()),
    closeCreateReturnReasonModal: () => dispatch(closeCreateReturnReasonModal()),
    setReturnReasonDetails: (data) => dispatch(setReturnReasonDetails(data)),
    setIsInlineUpdate: (itemId) => dispatch(setIsInlineUpdate(itemId)),
    updateReturnReason: (itemId) => dispatch(updateReturnReason(itemId)),

});
export default connect(mapStateToProps, mapDispatchToProps)(ReturnReasonList);